import React from 'react';
const AnimationContext = React.createContext(false);
export default AnimationContext;
